import { Controller } from "@hotwired/stimulus"
import { Chart, ArcElement, Tooltip, Legend, PieController } from 'chart.js'

// Register Chart.js components
Chart.register(ArcElement, Tooltip, Legend, PieController)

export default class extends Controller {
  static values = {
    data: Object,
    year: String
  }

  connect() {
    console.log('🚀 FinancialChartsController v1.0 loaded')
    this.renderChart()
  }

  renderChart() {
    if (!this.dataValue || !this.dataValue.labels || !this.dataValue.values) {
      console.warn('Chart data not available', this.dataValue)
      return
    }

    // this.element IS the canvas when data-controller is on the canvas tag
    const ctx = this.element

    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy()
    }

    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.dataValue.labels,
        datasets: [{
          data: this.dataValue.values,
          backgroundColor: [
            '#8B1538', // Dark red/maroon
            '#A31D4B', // Medium red
            '#C9385A', // Light red
            '#E55369', // Lighter red
            '#FF6E7B'  // Lightest red
          ],
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 15,
              font: {
                size: 12
              },
              generateLabels: (chart) => {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map((label, i) => {
                    const value = data.datasets[0].data[i]
                    const total = data.datasets[0].data.reduce((a, b) => a + b, 0)
                    const percentage = ((value / total) * 100).toFixed(1)
                    return {
                      text: `${label}: ${percentage}%`,
                      fillStyle: data.datasets[0].backgroundColor[i],
                      hidden: false,
                      index: i
                    }
                  })
                }
                return []
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || ''
                const value = context.parsed || 0
                const total = context.dataset.data.reduce((a, b) => a + b, 0)
                const percentage = ((value / total) * 100).toFixed(1)
                return `${label}: ${percentage}%`
              }
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
